import React from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import { BLOCK_FILTERS } from '../constants/common';

const { ActionButton } = designSystem;

const FilterButton = ({ id, label, isSelected = false, iconGlyph = null, onBlocksFilterClick }) => {
  const handleClick = () => {
    const filterId = isSelected ? BLOCK_FILTERS.none : id;

    onBlocksFilterClick(filterId);
  };

  return (
    <ActionButton
      size="small"
      appearance={isSelected ? 'accent' : 'default'}
      iconGlyph={iconGlyph}
      selected={isSelected}
      label={label}
      onClick={handleClick}
    />
  );
};

FilterButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isSelected: PropTypes.bool,
  iconGlyph: PropTypes.string,
  onBlocksFilterClick: PropTypes.func.isRequired,
};

export default FilterButton;
